// extracted by mini-css-extract-plugin
module.exports = {"paneOne":"style_paneOne__3Pppy"};